/* Standish WoodStory — Garden Trellis companion
   Edit copy here. Winnie-voice, from the video — not Spetz. */

(function () {
  "use strict";

  function asset(path) {
    const key = String(path || "").replace(/^images\//, "");
    if (window.WS_TRELLIS_ASSETS && window.WS_TRELLIS_ASSETS[key]) {
      return window.WS_TRELLIS_ASSETS[key];
    }
    return path;
  }

  const VIDEO_ID = "GVfDXQm4kF4";
  const STORAGE_DONE = "sws-trellis-done";
  const STORAGE_CHECKS = "sws-trellis-checks";

  const STEPS = [
    {
      t: 0,
      stamp: "0:00",
      title: "Let’s start this WoodStory",
      still: asset("images/thumb.jpg"),
      stillAlt: "Finished fan trellis standing in a garden bed",
      body: "Hey. Let’s start this WoodStory. This is a beginner trellis — under an hour, one board, done. Stores sell these for about thirty-five, forty dollars. End height is six feet. Grab longer lumber if you want it taller."
    },
    {
      t: 30,
      stamp: "0:30",
      title: "Grab your board and hardware",
      still: asset("images/still-prep.jpg"),
      stillAlt: "Marking a square line on a store board",
      body: "One 2×6 × 8′ board from the store. Cedar or pressure-treated lasts longer outdoors. Cheap pine is fine if it’s just for you — mine from last year still looks good. Coat it after if you need to. Hardware: two 3-inch outdoor screws, outdoor glue, brads or extra screws, and painter’s tape."
    },
    {
      t: 83,
      stamp: "1:23",
      title: "Square the ends",
      still: asset("images/still-prep.jpg"),
      stillAlt: "Speed square and pencil on the end of the board",
      body: "I trim the cracked ends first, so yours might come out a touch shorter than six feet. That’s alright. Square a line and cut them clean."
    },
    {
      t: 120,
      stamp: "2:00",
      title: "Rip the long strips",
      still: asset("images/still-rip.jpg"),
      stillAlt: "Ripping a long board into strips on the table saw",
      body: "Rip strips about ¾ inch, then rotate and rip again to about ¾ by ¾ — don’t overthink it. You want at least four long strips per trellis. Same board can give you two or three trellises if you’re making a few to sell. Rip the extras while the saw is set up."
    },
    {
      t: 174,
      stamp: "2:54",
      title: "Cut the three crossbars",
      still: asset("images/still-crossbars.jpg"),
      stillAlt: "Cutting a square strip to length at the miter saw",
      body: "All three come from one strip: 25½ inches for the top, 18 for the middle, 11½ for the bottom."
    },
    {
      t: 212,
      stamp: "3:32",
      title: "Join the four longs",
      still: asset("images/still-assemble.jpg"),
      stillAlt: "Glue, tape, and strips on the bench ready to join",
      body: "Tape or clamp the four longs together. Mark 5 inches from the bottom. Pre-drill. Two 3-inch outdoor screws from opposite directions, plus outdoor glue at the pivot. That’s the hinge that lets it fan."
    },
    {
      t: 327,
      stamp: "5:27",
      title: "Fan it out, add the bars",
      still: asset("images/still-assemble.jpg"),
      stillAlt: "Setting a crossbar across the fanned strips",
      body: "Mark the crossbar spots BEFORE you fan: about 4 inches from the top, 2 feet from the bottom, and split the difference for the middle. Straight-edge across all four. Then fan it out — don’t let go of the spring — and nail (or pre-drill and screw) the shortest bar first, then the middle, then the top. Glue the cross pieces too."
    },
    {
      t: 600,
      stamp: "10:00",
      title: "Stand it up",
      still: asset("images/thumb.jpg"),
      stillAlt: "Finished trellis in the garden",
      body: "That’s it. Plant it, lean it, sell a few if you want. Coat it if it’s going to live outside."
    }
  ];

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  let mode = "watch";
  let current = 0;
  let player = null;
  let done = loadDone();

  function loadDone() {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_DONE) || "[]");
      return Array.isArray(raw) ? raw.map(Boolean) : STEPS.map(() => false);
    } catch (e) {
      return STEPS.map(() => false);
    }
  }
  function saveDone() {
    try { localStorage.setItem(STORAGE_DONE, JSON.stringify(done)); } catch (e) {}
  }

  function amazonUrl(query) {
    return "https://www.amazon.com/s?k=" + encodeURIComponent(query) + "&tag=standishwoo04-20";
  }

  window.onYouTubeIframeAPIReady = function () {
    const mount = $("#player");
    if (!mount || typeof YT === "undefined" || !YT.Player) return;
    player = new YT.Player("player", {
      videoId: VIDEO_ID,
      host: "https://www.youtube.com",
      playerVars: {
        enablejsapi: 1,
        rel: 0,
        modestbranding: 1,
        playsinline: 1,
        origin: location.protocol === "file:" ? "https://www.youtube.com" : location.origin
      }
    });
  };

  function seekVideo(seconds) {
    if (player && typeof player.seekTo === "function") {
      try {
        player.seekTo(seconds, true);
        if (typeof player.playVideo === "function") player.playVideo();
        return;
      } catch (e) { /* fall through */ }
    }
    const iframe = $("#player");
    if (iframe && iframe.tagName === "IFRAME") {
      iframe.src =
        "https://www.youtube.com/embed/" +
        VIDEO_ID +
        "?enablejsapi=1&rel=0&modestbranding=1&playsinline=1&autoplay=1&start=" +
        Math.floor(seconds);
    }
  }

  function renderSteps() {
    const list = $("#step-list");
    if (!list) return;
    list.innerHTML = STEPS.map((s, i) => {
      const cls = [
        "step-btn",
        i === current ? "is-current" : "",
        done[i] ? "is-done" : ""
      ].join(" ").trim();
      return (
        '<li>' +
          '<button type="button" class="' + cls + '" data-step="' + i + '" aria-current="' + (i === current ? "step" : "false") + '">' +
            '<span class="step-num" aria-hidden="true">' + (done[i] ? "✓" : (i + 1)) + "</span>" +
            '<span>' +
              '<span class="step-stamp">' + s.stamp + "</span>" +
              '<span class="step-title">' + s.title + "</span>" +
            "</span>" +
          "</button>" +
        "</li>"
      );
    }).join("");
  }

  function renderRead() {
    const s = STEPS[current];
    const img = $("#read-still");
    const kicker = $("#read-kicker");
    const title = $("#read-title");
    const body = $("#read-body");
    const doneBtn = $("#mark-done");
    if (img) {
      img.src = s.still;
      img.alt = s.stillAlt;
    }
    if (kicker) kicker.textContent = "Step " + (current + 1) + " of " + STEPS.length + " · " + s.stamp;
    if (title) title.textContent = s.title;
    if (body) body.textContent = s.body;
    if (doneBtn) {
      doneBtn.setAttribute("aria-pressed", done[current] ? "true" : "false");
      doneBtn.textContent = done[current] ? "Done ✓" : "Mark step done";
    }
    const prev = $("#prev-step");
    const next = $("#next-step");
    if (prev) prev.disabled = current === 0;
    if (next) {
      next.disabled = current === STEPS.length - 1;
      next.textContent = current === STEPS.length - 1 ? "That’s the last step" : "Next step";
    }
  }

  function renderProgress() {
    const n = STEPS.length;
    const label = $("#progress-label");
    const bar = $("#progress-bar");
    const doneCount = done.filter(Boolean).length;
    if (label) {
      label.textContent = "Step " + (current + 1) + " of " + n + (doneCount ? " · " + doneCount + " marked done" : "");
    }
    if (bar) {
      bar.style.width = ((current + 1) / n) * 100 + "%";
      bar.parentElement.setAttribute("aria-valuenow", String(current + 1));
      bar.parentElement.setAttribute("aria-valuemax", String(n));
    }
  }

  function setMode(next) {
    mode = next;
    const watchPanel = $("#watch-panel");
    const readPanel = $("#read-panel");
    const watchBtn = $("#mode-watch");
    const readBtn = $("#mode-read");
    if (watchPanel) watchPanel.hidden = mode !== "watch";
    if (readPanel) readPanel.hidden = mode !== "read";
    if (watchBtn) watchBtn.setAttribute("aria-pressed", mode === "watch" ? "true" : "false");
    if (readBtn) readBtn.setAttribute("aria-pressed", mode === "read" ? "true" : "false");
  }

  function goTo(i, opts) {
    const play = opts && opts.play;
    current = Math.max(0, Math.min(STEPS.length - 1, i));
    renderSteps();
    renderRead();
    renderProgress();
    if (play || mode === "watch") seekVideo(STEPS[current].t);
    const heading = $("#read-title");
    if (mode === "read" && heading) heading.focus();
  }

  function setUnits(which) {
    document.body.classList.toggle("units-imperial", which === "imperial");
    document.body.classList.toggle("units-metric", which === "metric");
    document.querySelectorAll("[data-trellis-companion]").forEach(function (el) {
      el.classList.toggle("units-imperial", which === "imperial");
      el.classList.toggle("units-metric", which === "metric");
    });
    $$("[data-units]").forEach((btn) => {
      btn.setAttribute("aria-pressed", btn.getAttribute("data-units") === which ? "true" : "false");
    });
    const live = $("#units-live");
    if (live) live.textContent = which === "metric" ? "Cut list in millimetres" : "Cut list in inches";
  }

  function setShopTab(_id) {
    /* Tabs removed — all shop panels visible via .shop-grid. Stub kept for query-param compatibility. */
    $$(".panel").forEach((p) => { p.hidden = false; });
  }

  function wireAmazon() {
    $$("[data-amazon]").forEach((a) => {
      const q = a.getAttribute("data-amazon");
      a.href = amazonUrl(q);
      a.target = "_blank";
      a.rel = "noopener noreferrer";
    });
  }

  function persistChecks() {
    const state = {};
    $$("input[type=checkbox][data-check]").forEach((el) => {
      state[el.getAttribute("data-check")] = el.checked;
    });
    try { localStorage.setItem(STORAGE_CHECKS, JSON.stringify(state)); } catch (e) {}
  }
  function restoreChecks() {
    let state = {};
    try { state = JSON.parse(localStorage.getItem(STORAGE_CHECKS) || "{}"); } catch (e) {}
    $$("input[type=checkbox][data-check]").forEach((el) => {
      const k = el.getAttribute("data-check");
      if (k in state) el.checked = !!state[k];
    });
  }

  function openPrint() {
    const view = $("#print-view");
    if (!view) return;
    document.body.classList.add("print-open");
    document.querySelectorAll("[data-trellis-companion]").forEach(function (el) {
      el.classList.add("print-open");
    });
    view.hidden = false;
    const focusBtn = $("#print-close");
    if (focusBtn) focusBtn.focus();
  }
  function closePrint() {
    const view = $("#print-view");
    if (view) view.hidden = true;
    document.body.classList.remove("print-open");
    document.querySelectorAll("[data-trellis-companion]").forEach(function (el) {
      el.classList.remove("print-open");
    });
    const opener = $("#open-print");
    if (opener) opener.focus();
  }

  function onReady() {
    done = STEPS.map((_, i) => !!done[i]);
    renderSteps();
    renderRead();
    renderProgress();
    setMode("watch");
    setUnits("metric");
    wireAmazon();
    restoreChecks();
    setShopTab("panel-cuts");

    $("#step-list").addEventListener("click", (e) => {
      const btn = e.target.closest("[data-step]");
      if (!btn) return;
      goTo(Number(btn.getAttribute("data-step")), { play: mode === "watch" });
    });

    $("#mode-watch").addEventListener("click", () => {
      setMode("watch");
      seekVideo(STEPS[current].t);
    });
    $("#mode-read").addEventListener("click", () => {
      setMode("read");
      const heading = $("#read-title");
      if (heading) heading.focus();
    });

    $("#prev-step").addEventListener("click", () => goTo(current - 1, { play: false }));
    $("#next-step").addEventListener("click", () => goTo(current + 1, { play: false }));
    $("#mark-done").addEventListener("click", () => {
      done[current] = !done[current];
      saveDone();
      renderSteps();
      renderRead();
      renderProgress();
    });

    document.addEventListener("click", (e) => {
      const u = e.target.closest("[data-units]");
      if (u) setUnits(u.getAttribute("data-units"));
      if (e.target.closest("#open-print") || e.target.closest("#open-print-2")) openPrint();
      if (e.target.closest("#print-close")) closePrint();
      if (e.target.closest("#print-now")) window.print();
      if (e.target.closest("#clear-checks")) {
        $$("input[type=checkbox][data-check]").forEach((el) => { el.checked = false; });
        done = STEPS.map(() => false);
        saveDone();
        persistChecks();
        renderSteps();
        renderRead();
        renderProgress();
      }
    });

    document.addEventListener("change", (e) => {
      if (e.target.matches("input[type=checkbox][data-check]")) persistChecks();
    });

    document.addEventListener("keydown", (e) => {
      if (e.target.closest("input, textarea, select, a, button")) {
        if (e.key === "Escape" && !$("#print-view").hidden) closePrint();
        return;
      }
      if (e.key === "ArrowRight" || e.key === "n") goTo(current + 1, { play: false });
      if (e.key === "ArrowLeft" || e.key === "p") goTo(current - 1, { play: false });
      if (e.key === "Escape" && !$("#print-view").hidden) closePrint();
    });

    applyQueryState();
  }

  function applyQueryState() {
    const params = new URLSearchParams(location.search);
    const step = parseInt(params.get("step") || "", 10);
    if (!isNaN(step)) goTo(step, { play: false });
    if (params.get("mode") === "read") setMode("read");
    if (params.get("mode") === "watch") setMode("watch");
    if (params.get("units") === "metric") setUnits("metric");
    if (params.get("tab") === "tools") setShopTab("panel-tools");
    if (params.get("tab") === "hw") setShopTab("panel-hw");
    if (params.get("print") === "1") openPrint();
    if (params.get("view") === "shop" || params.get("scroll") === "cuts") {
      const ws = document.querySelector(".workspace");
      if (ws) ws.hidden = true;
      const sell = document.querySelector(".sell-note");
      if (sell) sell.hidden = true;
      const sub = document.querySelector(".subnav");
      if (sub) sub.hidden = true;
      const shop = document.querySelector(".shop");
      if (shop) {
        requestAnimationFrame(() => {
          shop.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
    }
    if (params.get("selftest") === "1") runSelfTest();
  }

  function runSelfTest() {
    const log = [];
    const startTitle = document.querySelector(".step-btn.is-current .step-title");
    log.push("start=" + (startTitle ? startTitle.textContent : "none"));

    document.querySelector('[data-step="3"]').click();
    log.push("after-step3=" + document.querySelector(".step-btn.is-current .step-title").textContent);
    const iframe = document.getElementById("player");
    log.push("iframe-src=" + (iframe && iframe.src ? iframe.src : iframe && iframe.tagName));

    document.getElementById("mode-read").click();
    log.push("read-hidden=" + document.getElementById("read-panel").hidden);
    log.push("watch-hidden=" + document.getElementById("watch-panel").hidden);
    log.push("read-pressed=" + document.getElementById("mode-read").getAttribute("aria-pressed"));

    document.getElementById("mark-done").click();
    log.push("done=" + document.getElementById("mark-done").getAttribute("aria-pressed"));

    document.getElementById("mode-watch").click();
    log.push("back-watch=" + document.getElementById("mode-watch").getAttribute("aria-pressed"));

    const box = document.querySelector('[data-check="cut-long"]');
    box.click();
    log.push("checkbox=" + box.checked);

    document.querySelector('[data-units="metric"]').click();
    log.push("metric=" + document.body.classList.contains("units-metric"));
    document.querySelector('[data-units="imperial"]').click();
    log.push("imperial=" + document.body.classList.contains("units-imperial"));

    const amz = document.querySelector('[data-amazon="table saw"]');
    log.push("amazon=" + amz.href);

    document.getElementById("open-print").click();
    log.push("print-open=" + !document.getElementById("print-view").hidden);
    document.getElementById("print-close").click();
    log.push("print-closed=" + document.getElementById("print-view").hidden);

    const pre = document.createElement("pre");
    pre.id = "selftest-out";
    pre.style.cssText = "background:#0a3d41;color:#fff;padding:16px;font-size:13px;white-space:pre-wrap;";
    pre.textContent = log.join("\n");
    document.body.appendChild(pre);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
